import { useEffect, useMemo, useState } from 'react';

import { API_BASE_URL } from '../config';
import { NAVIGATION_ITEMS } from '../constants/navigationItems';
import { useAuth } from '../contexts/AuthContext';
import { scopedKey, getActiveAccountId } from '../utils/accountSession';

export function useVisibleNavItems() {
  const { getAuthHeaders } = useAuth();
  const [hiddenSidebarItemIds, setHiddenSidebarItemIds] = useState([]);

  useEffect(() => {
    let mounted = true;
    try {
      const cached = JSON.parse(localStorage.getItem(scopedKey('ui_preferences', getActiveAccountId())) || '{}');
      if (Array.isArray(cached?.hidden_sidebar_item_ids)) {
        setHiddenSidebarItemIds(cached.hidden_sidebar_item_ids);
      }
    } catch {
      // ignore parse issues
    }
    const fetchUiPreferences = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/config/general`, {
          headers: getAuthHeaders?.() || {},
        });
        if (!response.ok) return;
        const data = await response.json();
        const hidden = data?.config?.ui_preferences?.hidden_sidebar_item_ids;
        if (!mounted) return;
        setHiddenSidebarItemIds(Array.isArray(hidden) ? hidden : []);
      } catch {
        // keep defaults when settings are unavailable
      }
    };
    fetchUiPreferences();
    const onUiPreferenceUpdate = (event) => {
      const hidden = event?.detail?.hidden_sidebar_item_ids;
      if (Array.isArray(hidden)) {
        setHiddenSidebarItemIds(hidden);
      }
    };
    window.addEventListener('ui-preferences-updated', onUiPreferenceUpdate);
    return () => {
      mounted = false;
      window.removeEventListener('ui-preferences-updated', onUiPreferenceUpdate);
    };
  }, [getAuthHeaders]);

  const visibleItems = useMemo(
    () => NAVIGATION_ITEMS.filter((item) => !hiddenSidebarItemIds.includes(item.id)),
    [hiddenSidebarItemIds],
  );

  return { visibleItems, hiddenSidebarItemIds };
}
